export function isFioChangeMissingIdFile(
  changes: Record<string, unknown>,
  files: Record<string, File>,
): boolean {
  const general = changes["general"] as Record<string, unknown> | undefined;
  const isFioChanged =
    !!general && ("surname" in general || "name" in general || "father_name" in general);
  return isFioChanged && !files["id_documents.national_id_file"];
}
